import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthdataService } from '../authdata.service';





@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

 
 
 
 
  messageError:any;
  rForm:any;


  

  constructor(private _AuthdataService:AuthdataService , private _Router:Router    ) {
    

    




  this.rForm = new FormGroup({

    'first_name':new FormControl('',[Validators.required, Validators.maxLength(10), Validators.minLength(3)]),
    'last_name': new FormControl('',[Validators.required, Validators.maxLength(10), Validators.minLength(3)]),
    'age': new FormControl('',[Validators.required,Validators.min(18), Validators.max(45)]),
    'email': new FormControl('',[Validators.email,  Validators.required]),
    'password':new FormControl('',[Validators.required, Validators.minLength(8)]),
  });

  }




  
getUserData(FormData:FormGroup){

  console.log(FormData);

  this._AuthdataService.getSignUp(FormData.value).subscribe((data)=>{
    console.log(data.message);
    


    if(data.message == "success"){

      this._Router.navigate([`/login`])
    }else {

      this.messageError= data.message

    }
  
    
  })
  
  
  }



  ngOnInit(): void {
  }

}
